import { createLogger } from '@kilat/shared';
import { env } from './env.js';

export const logger = createLogger({
  app: 'marketing',
  minLevel: env.mode === 'production' ? 'info' : 'debug',
  suppressed: env.mode === 'test',
});
